import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
@Component({
  selector: 'app-agent-image-popup',
  templateUrl: './agent-image-popup.component.html',
  styleUrls: ['./agent-image-popup.component.scss']
})
export class AgentImagePopupComponent implements OnInit {
  image: any;

  constructor(public dialogRef: MatDialogRef<AgentImagePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private http: HttpService) { 
      console.log(data);
      this.http.getAgentImage(data).subscribe((data)=> {
        console.log(data)
        this.image = data['image']
      })
    }

  ngOnInit() {
  }

}
interface DialogData {
  agent_id: number;
  image_type: '';
}
